export const firebaseCustomApp = {
	appId: "1:780837516549:web:55778823c350e4a96d736c",
	measurementId: "G-XJ9JRCHQ1S",
};
